/**
 * 
 */
declare const window:any;
export default function(){
    let oneClickDeployHtml:string = '';
    if(typeof(window.NetstarApiConfig.login)=='object' && typeof(window.NetstarApiConfig.login.onClickDeploy)=='object'){
        if(window.NetstarApiConfig.login.onClickDeploy.userName && window.NetstarApiConfig.login.onClickDeploy.pwd){
            oneClickDeployHtml = '<span><a href="javascript:void(0);" id="btn-invitationdeploy">一键部署</a> </span>';
        }
    }
    window.jQuery('.footer').append('<span><a href="javascript:void(0);" id="btn-invitationcode">授权文件下载</a> </span> <span><a target="_blank" id="btn-authorization-code">注册</a></span>'+oneClickDeployHtml);
    window.jQuery('body').append(`<div class="pt-modal" id="dialog-netstar-empower"  style="display:none">
        <div class="pt-container">
            <div class="pt-modal-content" style="width: 500px; height:380px; left:50%;margin-left:-200px;top:50%;margin-top:-200px">
                <div class="pt-modal-header">
                    <div class="pt-title">
                        <h4>授权码注册</h4>
                    </div>
                    <div class="pt-close" id="dialog-netstar-close-btn">
                        <button type="button" class="pt-btn pt-btn-icon pt-btn-circle" ns-name="close">
                            <i class="icon-close"></i>
                        </button>
                    </div>
                </div>
                <div class="pt-modal-body">
                    <div class="pt-form-group fg-textarea" style="width: 100%;">
                        <label class="pt-control-label"></label>
                        <div class="pt-textarea pt-input-group pt-text-assistant" style="width: 100%;">
                            <textarea placeholder=""id="form-empower-vo-0-license" class="pt-form-control" style="height: 270px;width: 100%;" ns-name="license"></textarea>
                        </div>
                    </div>
                </div>
                <div class="pt-modal-footer text-right">
                    <div class="pt-btn-group-container">
                        <div class="pt-btn-group pt-btn-group-gutter">
                            <button id="btn-default-register" type="button" class="pt-btn pt-btn-success" ns-name="confirm">
                                <i class="icon-save"></i>
                                <span>注册</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-modal-bg">
        </div>
    </div>`);
    var $dialogId = window.jQuery('#dialog-netstar-empower');//整体弹框
    var $closebtn = window.jQuery('#dialog-netstar-close-btn');//关闭按钮

    var $form = $dialogId.find('.pt-modal-body');
    var $btn = $dialogId.find('.pt-btn-group-container').children();

    var $title = $dialogId.find('.pt-title > h4');
    window.jQuery('#btn-invitationcode').on('click', function () {
        var ajaxConfig = {
            url: window.NetstarApiConfig.path +"proxy/authcode/authcode/licenseLimss/createRegInfo ",
            // data: data,
            method: "POST",
            contentType: "application/x-www-form-urlencoded",
            success: function (res, textStatus, request) {
                if (res.msg) {
                    window.nsalert(res.msg, 'error');
                }
                if (!res) {
                    window.nsalert('返回数据为空', 'error');
                    console.error('返回数据为空')
                    return false
                }
                $dialogId.css('display', 'none');
                var blob = new Blob([res]);
                var filename = "";
                var disposition = request.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }
                var a = document.createElement('a');
                a.download = filename;
                a.href = window.URL.createObjectURL(blob);
                a.click();
            },
            error:function(res){
                console.error(res);
                var status = res.status;
                let ajaxErrorInfo = window.language.ajaxErrorInfo;
                window.nsalert(ajaxErrorInfo.default[status],'error');
            }
        };
        window.jQuery.ajax(ajaxConfig);
    });
    window.jQuery('#btn-authorization-code').on('click', function () {
        var $uploadBtn = window.jQuery('#btn-default-register');//注册
        $uploadBtn.click('click', function () {
            var license = window.jQuery('#form-empower-vo-0-license').val();
            var ajaxConfig = {
                url: window.NetstarApiConfig.path + "proxy/authcode/authcode/licenseLimss/registry?license="+encodeURIComponent(license),
                method: "POST",
                contentType: "application/json;charset=UTF-8",
                processData: false,
                success: function (res) {
                    if (res.msg) {
                        window.nsalert(res.msg, 'error');
                    }
                    if (res.success) {
                        $dialogId.css('display', 'none');
                        window.nsalert('成功')
                    }
                },
                error:function(res){
                    console.error(res);
                    var status = res.status;
                    let ajaxErrorInfo = window.language.ajaxErrorInfo;
                    window.nsalert(ajaxErrorInfo.default[status],'error');
                }
            }
            window.jQuery.ajax(ajaxConfig)
        });

        $dialogId.css('display', '');

    });
    $closebtn.on('click', function () {
        $dialogId.css('display', 'none');
    });
    window.jQuery('#btn-invitationdeploy').on('click', function () {
        window.NSLogin.loginManger.submit({},{loginParamsType:"deploy"});
    });
}